
import { getDseV1Address,getDNDAddress } from 'utils/addressHelpers'
import { useWallet } from '@binance-chain/bsc-use-wallet'

export const addDND2Metamask=(ethereum)=>{
	const tokenAddress = getDNDAddress();
	const tokenSymbol = 'DND';
	const tokenDecimals = 18;
	const tokenImage = `${process.env.REACT_APP_FARM_ROOT}images/dungeon/coin_logo.png`;
	add2Metamask(ethereum,tokenAddress,tokenSymbol,tokenDecimals,tokenImage)
}

export const addDSE2Metamask=(ethereum)=>{
	const tokenAddress = getDseV1Address();
	const tokenSymbol = 'DSE';
	const tokenDecimals = 0;
	const tokenImage = `${process.env.REACT_APP_FARM_ROOT}images/dungeon/coin_logo.png`;
	add2Metamask(ethereum,tokenAddress,tokenSymbol,tokenDecimals,tokenImage)
}

export const add2Metamask=async (ethereum,tokenAddress:string,tokenSymbol:string,tokenDecimals:number,tokenImage:string)=>{
	try {
	  // wasAdded is a boolean. Like any RPC method, an error may be thrown.
	  const wasAdded = await ethereum.request({
		method: 'wallet_watchAsset',
		params: {
		  type: 'ERC20', // Initially only supports ERC20, but eventually more!
		  options: {
			address: tokenAddress, // The address that the token is at.
			symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
			decimals: tokenDecimals, // The number of decimals in the token
			image: tokenImage, // A string url of the token logo
		  },
		},
	  });
	
	  if (wasAdded) {
		console.log('Thanks for your interest!');
	  } else {
		console.log('Your loss!');
	  }
	} catch (error) {
	  console.log(error);
	}
}